// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"750a3a10","894":"6fc45cdb","928":"ee627cd4"}[chunkId] + ".chunk.css";
};